module.exports = __webpack_public_path__ + "assets/202509252035/img/screenshot-20241203-200513.8149bad8.png";